$(function() {
    FeaturesDisplay.init();
});
